export default __webpack_public_path__ + "static/media/karthik_balakrishnan.39f7ff68.jpg";